/** Drop keys axios would stringify awkwardly; keeps query strings clean. */
export function compactParams(
  params?: Record<string, string | number | boolean | null | undefined>
): Record<string, string | number | boolean> | undefined {
  if (!params) return undefined;
  const entries = Object.entries(params).filter(
    ([, v]) => v !== undefined && v !== null && v !== ""
  );
  if (entries.length === 0) return undefined;
  return Object.fromEntries(entries) as Record<
    string,
    string | number | boolean
  >;
}
